import { render } from "./OnePricingPlan.vue?vue&type=template&id=fe1c220c&scoped=true"
import script from "./OnePricingPlan.vue?vue&type=script&lang=js"
export * from "./OnePricingPlan.vue?vue&type=script&lang=js"

import "./OnePricingPlan.vue?vue&type=style&index=0&id=fe1c220c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe1c220c"]])

export default __exports__